unit UTransferList;

interface

uses
  System.Contnrs, UTransferModel, Js, WebLib.ExtCtrls, UEssentialHelper;

type
  TTransferList = class(TObjectList)
  private
    FTimer: TTimer;
    FUrl: string;
    FOnListChanged: TListChangedEvent;
    function GetItem(i: Integer): TTransferModel;
    procedure DoListChanged;
    procedure DoTimer(Sender: TObject);
    procedure HandleTransmit(Sender: TObject);
    procedure TransmitItem;
    procedure SetValues(obj: TJsObject); overload;
  public
    constructor Create(Url: string);
    function ToJson: string;
    procedure SetValues(Json: string); overload;
    procedure Add(Item: TTransferModel);
    property Items[i: Integer]: TTransferModel read GetItem;
    property OnListChanged: TListChangedEvent read FOnListChanged
      write FOnListChanged;
  end;

implementation

uses
  WebLib.Json, System.SysUtils, WebLib.REST, WebLib.Controls,
  WebLib.LocalFiles, UAttachmentList, WebLib.Storage, UAttachmentModel,
  UWebReportUtils, UFakModel;

{ TTransferList }

procedure TTransferList.Add(Item: TTransferModel);
begin
  inherited Add(Item);
  TLocalStorage.SetValue('TransferList', Self.ToJson);
  if Self.Count > 0 then
    FTimer.Enabled := true
  else
    FTimer.Enabled := false;
end;

constructor TTransferList.Create(Url: string);
var
  s: string;
begin
  inherited Create;
  FUrl := Url;
  FOnListChanged := nil;
  FTimer := TTimer.Create(nil);
  FTimer.Interval := 1000;
  FTimer.OnTimer := DoTimer;
  FTimer.Enabled := false;
  s := TLocalStorage.GetValue('TransferList');
  if s <> '' then
    Self.SetValues(s)
  else
    Self.Clear;
end;

procedure TTransferList.DoListChanged;
begin
  if Assigned(Self.OnListChanged) then
    Self.OnListChanged(Self);
end;

procedure TTransferList.DoTimer(Sender: TObject);
var
  client: TRestClient;
  procedure HandleError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    FTimer.Enabled := true;
  end;

  procedure DoResponse(Sender: TObject; AResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(AResponse);
    if (obj['value'] <> nil) and (string(obj['value']) = '1') then
      Self.TransmitItem
    else
      FTimer.Enabled := true;
  end;

begin
  FTimer.Enabled := false;
  if Self.Count > 0 then
  begin
    client := TRestClient.Create(nil);
    client.OnError := HandleError;
    client.OnResponse := DoResponse;
    client.HttpsGet(FUrl + '/TestService/Ping');
  end
  else
    Self.DoListChanged;
end;

function TTransferList.GetItem(i: Integer): TTransferModel;
begin
  Result := inherited GetItem(i) as TTransferModel;
end;

procedure TTransferList.HandleTransmit(Sender: TObject);
var
  model: TTransferModel;
  lst: TAttachmentList;
  aItem: TAttachmentModel;
  repLst: TReportList;
  fak: TFakModel;
  procedure HandleListChanged(Sender: TObject);
  var
    rItem: TReport;
  begin
    rItem := repLst.GetByPathAndFilename(model.FakNr + '\Pdfs', model.Filename);
    if rItem <> nil then
    begin
      rItem.TransmittedAt := now;
      repLst.Store;
    end;
  end;

begin
  if Sender is TTransferModel then
  begin
    model := Sender as TTransferModel;
    lst := TAttachmentList.Create;
    lst.FakNr := model.FakNr;
    lst.PersonalNr := model.PersonalNr;
    lst.Kind := akUnknown;
    lst.Load;
    aItem := lst.GetByKindAndFilename(model.Kind, model.Filename);
    if aItem <> nil then
    begin
      aItem.TransmittedAt := now;
      lst.Store;
    end
    else
    begin
      repLst := TReportList.Create;
      repLst.OnListChanged := HandleListChanged;
      repLst.fak := TFakModel.Create;
      repLst.fak.Nr := model.FakNr;
      repLst.Load;
    end;
  end;
  Self.Delete(0);
  TLocalStorage.SetValue('TransferList', Self.ToJson);
  FTimer.Enabled := true;
end;

procedure TTransferList.SetValues(Json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(Json);
  Self.SetValues(obj);
end;

procedure TTransferList.SetValues(obj: TJsObject);
var
  i, Count: Integer;
begin
  Self.Clear;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TTransferModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

function TTransferList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson(false));
  Result := obj.ToJson;
  obj.Free;
end;

procedure TTransferList.TransmitItem;
var
  Item: TTransferModel;
  tFile: TTextFile;

  procedure HandleBinFile(Sender: TObject);
  var
    f: TTextFile;
    s: string;
    procedure HandleError(Sender: TObject; AMsg: string);
    begin
      FTimer.Enabled := true;
    end;

  begin
    if Sender is TTextFile then
    begin
      f := Sender as TTextFile;
      s := f.Text;
      if Pos('data', s) = 1 then
        System.Delete(s, 1, 22);
      s := Base64ToHex(s);
      Item.Data := s;
      Item.OnTransmitted := Self.HandleTransmit;
      Item.OnError := HandleError;
      Item.Transmit(FUrl);
    end;
  end;

  procedure HandleTextFile(Sender: TObject);
  var
    f: TTextFile;
    s: string;
    procedure HandleError(Sender: TObject; AMsg: string);
    begin
      FTimer.Enabled := true;
    end;

  begin
    if Sender is TTextFile then
    begin
      f := Sender as TTextFile;
      s := f.Text;
      Item.Data := s;
      Item.OnTransmitted := Self.HandleTransmit;
      Item.OnError := HandleError;
      Item.Transmit(FUrl);
    end;
  end;

  procedure HandlePdfFile(Sender: TObject);
  var
    f: TTextFile;
    s: string;
    p: Integer;
    procedure HandleError(Sender: TObject; AMsg: string);
    begin
      FTimer.Enabled := true;
    end;

  begin
    if Sender is TTextFile then
    begin
      f := Sender as TTextFile;
      s := f.Text;
      p := Pos('base64,', s);
      if p > 0 then
        System.Delete(s, 1, p + Length('base64,') - 1);
      s := Base64ToHex(s);
      Item.Data := s;
      Item.OnTransmitted := Self.HandleTransmit;
      Item.OnError := HandleError;
      Item.Transmit(FUrl);
    end;
  end;

begin
  if Self.Count > 0 then
  begin
    Item := Self.Items[0];
    case Item.Kind of
      akUnknown:
        ;
      akPicture:
        begin
          tFile := TTextFile.Create(nil);
          tFile.OnFileOpen := HandleBinFile;
          tFile.OpenFile(Item.FakNr + '\Pictures', Item.Filename);
        end;
      akComment:
        begin
          tFile := TTextFile.Create(nil);
          tFile.OnFileOpen := HandleTextFile;
          tFile.OpenFile(Item.FakNr + '\Comments', Item.Filename);
        end;
      akPdf:
        begin
          tFile := TTextFile.Create(nil);
          tFile.OnFileOpen := HandlePdfFile;
          if Item.Filename <> '' then
            tFile.OpenFile(Item.FakNr + '\Pdfs', Item.Filename)
          else
          begin
            Self.Delete(0);
            TLocalStorage.SetValue('TransferList', Self.ToJson);
            FTimer.Enabled := true;
          end;
        end;
    end;
  end
  else
    FTimer.Enabled := true;
end;

end.
